<template>
  <section>
    <c-form>
      <c-row class="my-2">
        <c-col>
          <h4>Podaj dane kontaktowe</h4>
        </c-col>
      </c-row>
      <c-row>
        <c-col class="col-lg-4 col-12">
          <c-input
              label="Imię i nazwisko"
              placeholder="Podaj swoje imię i nazwisko"
              v-model="fullName"
              :isValid="(savedAtLeastOnce && errors && Object.keys(errors).includes('customer_name')) ? false : null"
          ></c-input>
        </c-col>
        <c-col class="col-lg-4 col-12">
          <c-input
              label="Nr telefonu"
              placeholder="Podaj swój nr telefonu"
              v-model="phone"
              :isValid="(savedAtLeastOnce && errors && Object.keys(errors).includes('customer_phone')) ? false : null"
          ></c-input>
        </c-col>
        <c-col class="col-lg-4 col-12">
          <c-input
              label="Adres email"
              placeholder="Podaj swój adres email"
              v-model="email"
              type="email"
              :isValid="(savedAtLeastOnce && errors && Object.keys(errors).includes('customer_email')) ? false : null"
          ></c-input>
        </c-col>
      </c-row>
      <c-row class="my-2">
        <c-col>
          <h4>Podaj dane adresowe</h4>
        </c-col>
      </c-row>
      <c-row>
        <c-col class="col-sm-6 col-lg-3 col-12">
          <c-input
              name="street"
              label="Ulica"
              v-model="street"
              :isValid="(savedAtLeastOnce && errors && Object.keys(errors).includes('address_street')) ? false : null"
          ></c-input>
        </c-col>
        <c-col class="col-sm-3 col-lg-2 col-12">
          <c-input
              label="Nr domu"
              v-model="houseNumber"
              :isValid="(savedAtLeastOnce && errors && Object.keys(errors).includes('address_house_number')) ? false : null"
          ></c-input>
        </c-col>
        <c-col class="col-sm-3 col-lg-2 col-12">
          <c-input
              label="Nr mieszkania"
              v-model="flatNumber"
              :isValid="(savedAtLeastOnce && errors && Object.keys(errors).includes('address_flat_number')) ? false : null"
          ></c-input>
        </c-col>
        <c-col class="col-sm-6 col-lg-2 col-12">
          <c-input
              label="Kod pocztowy"
              v-model="postalCode"
              :isValid="(savedAtLeastOnce && errors && Object.keys(errors).includes('address_postal_code')) ? false : null"
          ></c-input>
        </c-col>
        <c-col class="col-sm-6 col-lg-3 col-12">
          <c-input
              label="Miejscowość"
              v-model="municipality"
              :isValid="(savedAtLeastOnce && errors && Object.keys(errors).includes('address_municipality')) ? false : null"
          ></c-input>
        </c-col>
      </c-row>
      <c-row class="my-2">
        <c-col>
          <h4>Wybierz metodę płatności</h4>
        </c-col>
      </c-row>
      <c-row class="my-2">
        <c-col>
          <c-input-radio-group :checked.sync="paymentMethod" v-bind:options="[
            { value: 'CA', label: 'Płatność gotówką przy odbiorze' },
            { value: 'TR', label: 'Płatność przelewem' }
        ]"></c-input-radio-group>
        </c-col>
      </c-row>
      <c-row class="my-2">
        <c-col>
          <h4>Dodaj uwagi do zamówienia (opcjonalnie)</h4>
        </c-col>
      </c-row>
      <c-row class="my-2">
        <c-col>
          <c-textarea v-model="notes"></c-textarea>
        </c-col>
      </c-row>
      <c-row class="my-2">
        <c-col>
          <h4>Weryfikacja</h4>
        </c-col>
      </c-row>
      <c-row class="my-2">
        <c-col>
          <vue-recaptcha ref="recaptcha"
                         sitekey="6Lf3A5cdAAAAABdxL8Z2OT_fw-GQuGZVzd0t3W8T"
                         :loadRecaptchaScript="true"></vue-recaptcha>
        </c-col>
      </c-row>
      <c-row class="my-4 align-items-start">
        <c-col>
          <c-button
              :disabled="saved && (!failed && !success)"
              v-on:click="onSaveOrder"
              v-if="$store.getters.totalPrice > 0"
              color="success">
            Potwierdzam zamówienie za
            {{ $store.getters.totalPricePlusDelivery.toFixed(2) }} zł
          </c-button>
          <c-button v-else color="success" disabled>
            Potwierdzam zamówienie
          </c-button>
          <br>
          <span class="pt-3" v-if="saved && (!failed && !success)">
          Proszę czekać, trwa zapisywanie...
          </span>
        </c-col>
      </c-row>
    </c-form>
    <c-modal title="Niepowodzenie"
             :close-on-backdrop="false" color="danger"
             :show.sync="showFailure">
      <p>Niestety, nie udało się zapisać Twojego zamówienia. Sprawdź poprawność
        wypełnionego formularza i spróbuj ponownie później.</p>
      <template v-slot:footer>
        <c-button color="primary"
                  v-on:click="onCloseModal">
          OK
        </c-button>
      </template>
    </c-modal>
  </section>
</template>
<script>
import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'CartForm',
  components: {VueRecaptcha},
  data() {
    return {
      saved: false,
      savedAtLeastOnce: false,
      failed: false,
      errors: {}
    }
  },
  methods: {
    isFieldValid(field) {
      if (this.savedAtLeastOnce && this.errors && Object.keys(this.errors).includes(field))
        return false
      return null
    },
    onCloseModal() {
      this.saved = false
      this.failed = false
      this.$refs.recaptcha.reset()
    },
    onSaveOrder() {
      this.saved = true
      this.savedAtLeastOnce = true
      axios
          .post(
              (typeof webpackHotUpdate !== 'undefined' ? 'http://localhost/admin/' : '/admin/') + 'api/create-new-order',
              {
                grecaptcha: eval('grecaptcha.getResponse()'),
                order: {
                  'payment_method': this.$store.state.paymentMethod,
                  'address_municipality': this.$store.state.municipality,
                  'address_street': this.$store.state.street,
                  'address_postal_code': this.$store.state.postalCode,
                  'address_house_number': this.$store.state.houseNumber,
                  'address_flat_number': this.$store.state.flatNumber,
                  'customer_name': this.$store.state.name,
                  'customer_phone': this.$store.state.phone,
                  'customer_email': this.$store.state.email,
                  'notes': this.$store.state.notes
                },
                items: this.$store.getters.products
                    .filter(prod => prod.pickCount !== 0)
                    .map(prod => ({
                      pk: prod.pk,
                      count: prod.pickCount
                    }))
              }
          )
          .then(res => {
            this.$store.commit('SET_SUCCESS_DATA', {
              orderId: res.data.order_id,
              deliveryDate: res.data.delivery_date,
              paymentMethod: this.$store.state.paymentMethod,
              bankAccount: res.data.bank_account || null
            })
            this.$store.commit('CLEAR_CART')
            this.$router.push('/success')
          })
          .catch(err => {
            this.failed = true
            this.errors = err.response.data.errors
          })

    }
  },
  computed: {
    showFailure() {
      return this.saved && this.failed
    },
    fullName: {
      get() {
        return this.$store.state.name
      },
      set(value) {
        this.$store.commit('SET_NAME', value)
      }
    },
    phone: {
      get() {
        return this.$store.state.phone
      },
      set(value) {
        this.$store.commit('SET_PHONE', value)
      }
    },
    email: {
      get() {
        return this.$store.state.email
      },
      set(value) {
        this.$store.commit('SET_EMAIL', value)
      }
    },
    paymentMethod: {
      get() {
        return this.$store.state.paymentMethod
      },
      set(value) {
        this.$store.commit('SET_PAYMENT_METHOD', value)
      }
    },
    houseNumber: {
      get() {
        return this.$store.state.houseNumber
      },
      set(value) {
        this.$store.commit('SET_HOUSE_NUMBER', value)
      }
    },
    flatNumber: {
      get() {
        return this.$store.state.flatNumber
      },
      set(value) {
        this.$store.commit('SET_FLAT_NUMBER', value)
      }
    },
    municipality: {
      get() {
        return this.$store.state.municipality
      },
      set(value) {
        this.$store.commit('SET_MUNICIPALITY', value)
      }
    },
    postalCode: {
      get() {
        return this.$store.state.postalCode
      },
      set(value) {
        this.$store.commit('SET_POSTAL_CODE', value)
      }
    },
    street: {
      get() {
        return this.$store.state.street
      },
      set(value) {
        this.$store.commit('SET_STREET', value)
      }
    },
    notes: {
      get() {
        return this.$store.state.notes
      },
      set(value) {
        this.$store.commit('SET_NOTES', value)
      }
    }
  }
}
</script>